export default "__VITE_ASSET__Z$i1r03p__"